/*
 * Function to add a Read More button to the excerpt
 */
export default function shortenExcerpt (excerpt) {
  var div = document.createElement('div')
  div.innerHTML = excerpt
  var text = div.textContent || div.innerText || ''
  return text
}
